import { number } from 'yup'
import { safify } from '../utils/safify'

export const brandKitId = number()
  .positive()
  .integer()
  .meta({ label: 'Select a Brand Kit', autoFill: true, featureFlags: { brand_kits: true } })
  .transform(safify)
